import DOMPurify from "dompurify";
import parse from "html-react-parser";
import "./articlecontent.css";

const ArticleContent = ({ content }) => {
  // Allow iframe and its attributes for YouTube embeds
  const cleanHtml = DOMPurify.sanitize(content, {
    ADD_TAGS: ["iframe"],
    ADD_ATTR: [
      "allow",
      "allowfullscreen",
      "frameborder",
      "scrolling",
      "src",
      "width",
      "height",
      "title",
      "referrerpolicy",
    ],
  });
  return (
    <div className="article-content d-flex flex-column">{parse(cleanHtml)}</div>
  );
};

export default ArticleContent;
